import React, { Component } from 'react'
import Icon from './Icon'

interface MenuFolderProps {
  fold: boolean
  onChange: () => void
}

export default class MenuFolder extends Component<MenuFolderProps> {
  get icon () {
    const status = this.props.fold ? 'unfold' : 'fold'
    return `menu-${status}`
  }

  render () {
    return (
      <Icon
        name={this.icon}
        size="large"
        color="white"
        className="cursor-pointer hidden sm:block"
        onClick={this.props.onChange} />
    )
  }
}
